import { TSLandingPage } from "../components/TSLandingPage";
import { Page, Action } from "@thoughtspot/visual-embed-sdk";
import { AppEmbedWrapper } from "../components/AppEmbed/AppEmbedWrapper";
import Layout from "../components/Layout";
import SecureRoute from "../components/SecureRoute";
import { DefaultSidebarBreakpoint } from "../components/SidebarToggle";
import { appEmbedWrapperCssRulesNoSaveView } from "../cssRules";
import { ContactUs } from "../pages/contactus/ContactUs";
import { SignOut } from "../pages/sign-out/SignOut";
import { Redirect } from "../Redirect";
import {
  GenerateSidebar,
  SubdomainOrgIdObject,
} from "./FunctionsAndInterfaces";
import { GroupAccessTool } from "../features/admin-menu/group-management/GroupAccessTool";
import { MenuItem } from "react-pro-sidebar";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faBox,
  faDoorOpen,
  faSuitcase,
} from "@fortawesome/free-solid-svg-icons";
import { AdminTileManagement } from "../features/admin-menu/landing-page-generator/AdminTileManagement";
import {
  prmgProdAdminLiveboards,
  prmgProdExecutiveLiveboards,
  prmgProdOperationsLiveboards,
  prmgProdRetailLiveboards,
  prmgProdWholesaleLiveboards,
  prmgUATAdminLiveboards,
  prmgUATExecutiveLiveboards,
  prmgUATOperationsLiveboards,
  prmgUATRetailLiveboards,
  prmgUATWholesaleLiveboards,
} from "./PRMGBackupButtons";
import { TSMetadataTool } from "../features/ts-metadata-tool/tsMetadataTool";

const orgIdProd: number = 428892831;
const subDomainProd: string = "prmgprod";
const nameOfProductProd: string = "PRMG";
const secureRouteGroupsProd: string[] = ["PRMG"];
const editableRightsGroupProd: string = "PRMGEDITINGRIGHTS";

const orgIdUAT: number = 581621867;
const subDomainUAT: string = "prmgUAT2";
const nameOfProductUAT: string = "PRMG UAT";
const secureRouteGroupsUAT: string[] = ["PRMGUAT"];
const editableRightsGroupUAT: string = "PRMGUATEDITINGRIGHTS";

const downloadAsCSVBypassGroup: string = "AllowCSVDownload";
const usersToSeeDataTab: string[] = ["jminier@prmg.net"];
const seeAdminTileGroup: string[] = ["AdminTileAccess"];
const seeChrisGaxTileGroup: string[] = ["ChrisGaxTileAccess"];

export const prmgProdObject: SubdomainOrgIdObject = {
  orgID: orgIdProd,
  path: subDomainProd,
  externalInfo: { subdomain: "prmg", productURL: "prmgprod" },
  editableRightsGroup: editableRightsGroupProd,
};

export const prmgUATObject: SubdomainOrgIdObject = {
  orgID: orgIdUAT,
  path: subDomainUAT,
  externalInfo: { subdomain: "prmg", productURL: "prmgUAT2" },
  editableRightsGroup: editableRightsGroupUAT,
};

const PRMGProdSidebarMenu = () => {
  return (
    <>
      <GenerateSidebar
        productTitle="PRMG"
        subDomainURL={subDomainProd}
        dynamicLandingPageObjectsCode={[
          {
            dynamicCode: {
              code: "PR_PROD_Executive",
              businessName: "Executive",
              backup: prmgProdExecutiveLiveboards,
            },
            order: 1,
          },
          {
            dynamicCode: {
              code: "PR_PROD_Operations",
              businessName: "Operations",
              backup: prmgProdOperationsLiveboards,
            },
            order: 2,
          },
          {
            dynamicCode: {
              code: "PR_PROD_Retail",
              businessName: "Retail",
              backup: prmgProdRetailLiveboards,
            },
            order: 3,
          },
          {
            dynamicCode: {
              code: "PR_PROD_Wholesale",
              businessName: "Wholesale - Correspondent",
              backup: prmgProdWholesaleLiveboards,
            },
            order: 4,
          },
          {
            dynamicCode: {
              code: "PR_PROD_Admin",
              businessName: "Admin",
            },
            order: 5,
            onlyShowForCognitoGroups: seeAdminTileGroup,
          },
          {
            dynamicCode: {
              code: "PR_PROD_ChrisGax",
              businessName: "Chris/Gax",
            },
            order: 6,
            onlyShowForCognitoGroups: seeChrisGaxTileGroup,
          },
        ]}
        otherObjects={{
          sidebarElement: (
            <div>
              <MenuItem>
                <Link to={`/${subDomainProd}/group-access`}>
                  <div className="sidebar-item">
                    <FontAwesomeIcon className="me-2" icon={faSuitcase} />
                    Group Access
                  </div>
                </Link>
              </MenuItem>
              <MenuItem>
                <Link to={`/${subDomainProd}/landing-page-management`}>
                  <div className="sidebar-item">
                    <FontAwesomeIcon className="me-2" icon={faBox} />
                    Landing Page Management
                  </div>
                </Link>
              </MenuItem>
              <MenuItem>
                <Link to={`/${subDomainProd}/metadata-download-tool`}>
                  <div className="sidebar-item">
                    <FontAwesomeIcon className="me-2" icon={faDoorOpen} />
                    Metadata Download Tool
                  </div>
                </Link>
              </MenuItem>
            </div>
          ),
          groupPermission: editableRightsGroupProd,
        }}
      />
    </>
  );
};

const prmgProdLandingPage = (
  <TSLandingPage
    smallButtons={false}
    parentURL={`/${subDomainProd}/product`}
    buttons={[
      [
        { title: "Search", description: "", link: "answer" },
        { title: "Liveboards", description: "", link: "pinboards/" },
      ],
      [
        {
          title: "Executive",
          description: "",
          link: `/${subDomainProd}/executivedashboards`,
          internal: true,
          overrideParentURL: true,
        },
        {
          title: "Admin",
          description: "",
          link: `/${subDomainProd}/admindashboards`,
          internal: true,
          overrideParentURL: true,
          onlyShowForCognitoGroups: seeAdminTileGroup,
        },
      ],
      [
        {
          title: "Operations",
          description: "",
          link: `/${subDomainProd}/operations`,
          internal: true,
          overrideParentURL: true,
        },
        {
          title: "Chris/Gax",
          description: "",
          link: `/${subDomainProd}/chrisgax`,
          internal: true,
          overrideParentURL: true,
        },
      ],
      [
        {
          title: "Retail",
          description: "",
          link: `/${subDomainProd}/retail`,
          internal: true,
          overrideParentURL: true,
        },
      ],
      [
        {
          title: "Wholesale - Correspondent",
          description: "",
          link: `/${subDomainProd}/wholesalecorrespondent`,
          internal: true,
          overrideParentURL: true,
        },
      ],
    ]}
  />
);

const prmgProdExecutiveLandingPage = (
  <TSLandingPage
    smallButtons={false}
    parentURL={`/${subDomainProd}/product`}
    buttons={[
      [
        {
          title: "Go Back",
          description: "",
          link: `/${subDomainProd}`,
          internal: true,
          overrideParentURL: true,
        },
      ],
      //...distributeObjects(prmgProdExecutiveLiveboards, 3),
    ]}
    dynamicButtonsCode={{
      code: "PR_PROD_Executive",
      businessName: "Executive",
      backup: prmgProdExecutiveLiveboards,
    }}
  />
);

const prmgProdOperationsLandingPage = (
  <TSLandingPage
    smallButtons={false}
    parentURL={`/${subDomainProd}/product`}
    buttons={[
      [
        {
          title: "Go Back",
          description: "",
          link: `/${subDomainProd}`,
          internal: true,
          overrideParentURL: true,
        },
      ],
      //...distributeObjects(prmgProdOperationsLiveboards, 3),
    ]}
    dynamicButtonsCode={{
      code: "PR_PROD_Operations",
      businessName: "Operations",
      backup: prmgProdOperationsLiveboards,
    }}
  />
);

const prmgProdRetailLandingPage = (
  <TSLandingPage
    smallButtons={false}
    parentURL={`/${subDomainProd}/product`}
    buttons={[
      [
        {
          title: "Go Back",
          description: "",
          link: `/${subDomainProd}`,
          internal: true,
          overrideParentURL: true,
        },
      ],
      //...distributeObjects(prmgProdRetailLiveboards, 3),
    ]}
    dynamicButtonsCode={{
      code: "PR_PROD_Retail",
      businessName: "Retail",
      backup: prmgProdRetailLiveboards,
    }}
  />
);

const prmgProdWholesaleLandingPage = (
  <TSLandingPage
    smallButtons={false}
    parentURL={`/${subDomainProd}/product`}
    buttons={[
      [
        {
          title: "Go Back",
          description: "",
          link: `/${subDomainProd}`,
          internal: true,
          overrideParentURL: true,
        },
      ],
      //...distributeObjects(prmgProdWholesaleLiveboards, 3),
    ]}
    dynamicButtonsCode={{
      code: "PR_PROD_Wholesale",
      businessName: "Wholesale",
      backup: prmgProdWholesaleLiveboards,
    }}
  />
);

const prmgProdAdminDashboardsLandingPage = (
  <TSLandingPage
    smallButtons={false}
    parentURL={`/${subDomainProd}/product`}
    buttons={[
      [
        {
          title: "Go Back",
          description: "",
          link: `/${subDomainProd}`,
          internal: true,
          overrideParentURL: true,
        },
      ],
    ]}
    dynamicButtonsCode={{
      code: "PR_PROD_Admin",
      businessName: "Admin",
    }}
  />
);

const prmgProdChrisGaxLandingPage = (
  <TSLandingPage
    smallButtons={false}
    parentURL={`/${subDomainProd}/product`}
    buttons={[
      [
        {
          title: "Go Back",
          description: "",
          link: `/${subDomainProd}`,
          internal: true,
          overrideParentURL: true,
        },
      ],
    ]}
    dynamicButtonsCode={{
      code: "PR_PROD_ChrisGax",
      businessName: "Chris/Gax",
    }}
  />
);

/* const prmgProdNonEditableLiveboards = populateNonEditableArray([
  prmgProdExecutiveLiveboards,
  prmgProdOperationsLiveboards,
  prmgProdRetailLiveboards,
  prmgProdWholesaleLiveboards,
]); */

const PRMGUATModeSidebarMenu = () => {
  return (
    <>
      <GenerateSidebar
        productTitle="PRMG UAT"
        subDomainURL={subDomainUAT}
        dynamicLandingPageObjectsCode={[
          {
            dynamicCode: {
              code: "PR_UAT_Executive",
              businessName: "Executive",
              backup: prmgUATExecutiveLiveboards,
            },
            order: 1,
          },
          {
            dynamicCode: {
              code: "PR_UAT_Operations",
              businessName: "Operations",
              backup: prmgUATOperationsLiveboards,
            },
            order: 2,
          },
          {
            dynamicCode: {
              code: "PR_UAT_Retail",
              businessName: "Retail",
              backup: prmgUATRetailLiveboards,
            },
            order: 3,
          },
          {
            dynamicCode: {
              code: "PR_UAT_Wholesale",
              businessName: "Wholesale - Correspondent",
              backup: prmgUATWholesaleLiveboards,
            },
            order: 4,
          },
          {
            dynamicCode: {
              code: "PR_UAT_Admin",
              businessName: "Admin",
            },
            order: 5,
            onlyShowForCognitoGroups: seeAdminTileGroup,
          },
          {
            dynamicCode: {
              code: "PR_UAT_ChrisGax",
              businessName: "Chris/Gax",
            },
            order: 6,
            onlyShowForCognitoGroups: seeChrisGaxTileGroup,
          },
        ]}
        otherObjects={{
          sidebarElement: (
            <>
              <div>
                <MenuItem>
                  <Link to={`/${subDomainUAT}/landing-page-management`}>
                    <div className="sidebar-item">
                      <FontAwesomeIcon className="me-2" icon={faBox} />
                      Landing Page Management
                    </div>
                  </Link>
                </MenuItem>
              </div>
              <div>
                <MenuItem>
                  <Link to={`/${subDomainUAT}/metadata-download-tool`}>
                    <div className="sidebar-item">
                      <FontAwesomeIcon className="me-2" icon={faDoorOpen} />
                      Metadata Download Tool
                    </div>
                  </Link>
                </MenuItem>
              </div>
            </>
          ),
          groupPermission: editableRightsGroupUAT,
        }}
      />
    </>
  );
};

const prmgUATLandingPage = (
  <TSLandingPage
    smallButtons={false}
    parentURL={`/${subDomainUAT}/product`}
    buttons={[
      [
        { title: "Search", description: "", link: "answer" },
        { title: "Liveboards", description: "", link: "pinboards/" },
      ],
      [
        {
          title: "Executive",
          description: "",
          link: `/${subDomainUAT}/executivedashboards`,
          internal: true,
          overrideParentURL: true,
        },
        {
          title: "Admin",
          description: "",
          link: `/${subDomainUAT}/admindashboards`,
          internal: true,
          overrideParentURL: true,
          onlyShowForCognitoGroups: seeAdminTileGroup,
        },
      ],
      [
        {
          title: "Operations",
          description: "",
          link: `/${subDomainUAT}/operations`,
          internal: true,
          overrideParentURL: true,
        },
        {
          title: "Chris/Gax",
          description: "",
          link: `/${subDomainUAT}/chrisgax`,
          internal: true,
          overrideParentURL: true,
        },
      ],
      [
        {
          title: "Retail",
          description: "",
          link: `/${subDomainUAT}/retail`,
          internal: true,
          overrideParentURL: true,
        },
      ],
      [
        {
          title: "Wholesale - Correspondent",
          description: "",
          link: `/${subDomainUAT}/wholesalecorrespondent`,
          internal: true,
          overrideParentURL: true,
        },
      ],
    ]}
  />
);

const prmgUATExecutiveLandingPage = (
  <TSLandingPage
    smallButtons={false}
    parentURL={`/${subDomainUAT}/product`}
    buttons={[
      [
        {
          title: "Go Back",
          description: "",
          link: `/${subDomainUAT}`,
          internal: true,
          overrideParentURL: true,
        },
      ],
      //...distributeObjects(prmgUATExecutiveLiveboards, 3),
    ]}
    dynamicButtonsCode={{
      code: "PR_UAT_Executive",
      businessName: "Executive",
      backup: prmgUATExecutiveLiveboards,
    }}
  />
);

const prmgUATOperationsLandingPage = (
  <TSLandingPage
    smallButtons={false}
    parentURL={`/${subDomainUAT}/product`}
    buttons={[
      [
        {
          title: "Go Back",
          description: "",
          link: `/${subDomainUAT}`,
          internal: true,
          overrideParentURL: true,
        },
      ],
      //...distributeObjects(prmgUATOperationsLiveboards, 3),
    ]}
    dynamicButtonsCode={{
      code: "PR_UAT_Operations",
      businessName: "Operations",
      backup: prmgUATOperationsLiveboards,
    }}
  />
);

const prmgUATRetailLandingPage = (
  <TSLandingPage
    smallButtons={false}
    parentURL={`/${subDomainUAT}/product`}
    buttons={[
      [
        {
          title: "Go Back",
          description: "",
          link: `/${subDomainUAT}`,
          internal: true,
          overrideParentURL: true,
        },
      ],
      //...distributeObjects(prmgUATRetailLiveboards, 3),
    ]}
    dynamicButtonsCode={{
      code: "PR_UAT_Retail",
      businessName: "Retail",
      backup: prmgUATRetailLiveboards,
    }}
  />
);

const prmgUATWholesaleLandingPage = (
  <TSLandingPage
    smallButtons={false}
    parentURL={`/${subDomainUAT}/product`}
    buttons={[
      [
        {
          title: "Go Back",
          description: "",
          link: `/${subDomainUAT}`,
          internal: true,
          overrideParentURL: true,
        },
      ],
      //...distributeObjects(prmgUATWholesaleLiveboards, 3),
    ]}
    dynamicButtonsCode={{
      code: "PR_UAT_Wholesale",
      businessName: "Wholesale",
      backup: prmgUATWholesaleLiveboards,
    }}
  />
);

const prmgUATAdminDashboardsLandingPage = (
  <TSLandingPage
    smallButtons={false}
    parentURL={`/${subDomainUAT}/product`}
    buttons={[
      [
        {
          title: "Go Back",
          description: "",
          link: `/${subDomainUAT}`,
          internal: true,
          overrideParentURL: true,
        },
      ],
    ]}
    dynamicButtonsCode={{
      code: "PR_UAT_Admin",
      businessName: "Admin",
    }}
  />
);

const prmgUATChrisGaxLandingPage = (
  <TSLandingPage
    smallButtons={false}
    parentURL={`/${subDomainUAT}/product`}
    buttons={[
      [
        {
          title: "Go Back",
          description: "",
          link: `/${subDomainUAT}`,
          internal: true,
          overrideParentURL: true,
        },
      ],
    ]}
    dynamicButtonsCode={{
      code: "PR_UAT_ChrisGax",
      businessName: "Chris/Gax",
    }}
  />
);

/* const prmgUATModeNonEditableLiveboards = populateNonEditableArray([
  prmgUATExecutiveLiveboards,
  prmgUATOperationsLiveboards,
  prmgUATRetailLiveboards,
  prmgUATWholesaleLiveboards,
]); */

export const prmgProdRoutes = {
  element: (
    <Layout
      breakPoint={DefaultSidebarBreakpoint}
      smallHeader={true}
      sidebarMenu={<PRMGProdSidebarMenu />}
      contactUsPath={`/${subDomainProd}/contactus`}
      signOutPath={`/${subDomainProd}/signout`}
    />
  ),
  children: [
    {
      path: `/${subDomainProd}`,
      element: (
        <SecureRoute
          productName={nameOfProductProd}
          element={prmgProdLandingPage}
          groups={secureRouteGroupsProd}
        />
      ),
    },
    {
      path: `/${subDomainProd}/executivedashboards`,
      element: (
        <SecureRoute
          productName={nameOfProductProd}
          element={prmgProdExecutiveLandingPage}
          groups={secureRouteGroupsProd}
        />
      ),
    },
    {
      path: `/${subDomainProd}/operations`,
      element: (
        <SecureRoute
          productName={nameOfProductProd}
          element={prmgProdOperationsLandingPage}
          groups={secureRouteGroupsProd}
        />
      ),
    },
    {
      path: `/${subDomainProd}/retail`,
      element: (
        <SecureRoute
          productName={nameOfProductProd}
          element={prmgProdRetailLandingPage}
          groups={secureRouteGroupsProd}
        />
      ),
    },
    {
      path: `/${subDomainProd}/wholesalecorrespondent`,
      element: (
        <SecureRoute
          productName={nameOfProductProd}
          element={prmgProdWholesaleLandingPage}
          groups={secureRouteGroupsProd}
        />
      ),
    },
    {
      path: `/${subDomainProd}/admindashboards`,
      element: (
        <SecureRoute
          productName={nameOfProductProd}
          element={prmgProdAdminDashboardsLandingPage}
          groups={seeAdminTileGroup}
        />
      ),
    },
    {
      path: `/${subDomainProd}/chrisgax`,
      element: (
        <SecureRoute
          productName={nameOfProductProd}
          element={prmgProdChrisGaxLandingPage}
          groups={seeChrisGaxTileGroup}
        />
      ),
    },
    {
      path: `/${subDomainProd}/product`,
      element: (
        <SecureRoute
          productName={nameOfProductProd}
          element={
            <AppEmbedWrapper
              cssRules={appEmbedWrapperCssRulesNoSaveView}
              disableFunctionality={[
                {
                  functionality: Action.DownloadAsCsv,
                  bypassGroup: downloadAsCSVBypassGroup,
                },
              ]}
              breakPoint={DefaultSidebarBreakpoint}
              showPrimaryNavbar={true}
              disableProfileAndHelp={true}
              className="ts-full-app h-100"
              pageId={Page.Liveboards}
              orgObject={prmgProdObject}
              disableEditButtonDynamicCodeArray={[
                {
                  code: "PR_PROD_Executive",
                  backup: prmgProdExecutiveLiveboards,
                },
                {
                  code: "PR_PROD_Operations",
                  backup: prmgProdOperationsLiveboards,
                },
                { code: "PR_PROD_Retail", backup: prmgProdRetailLiveboards },
                {
                  code: "PR_PROD_Wholesale",
                  backup: prmgProdWholesaleLiveboards,
                },
                {
                  code: "PR_PROD_Admin",
                  backup: prmgProdAdminLiveboards,
                },
                {
                  code: "PR_PROD_ChrisGax",
                  backup: [],
                },
              ]}
              bypassDataTabDisablingUserEmails={usersToSeeDataTab}
              activateDisableCheckForDomainAndGroup={{
                domain: subDomainProd,
                group: seeAdminTileGroup,
              }}
              productBlockCode="PRMG Prod"
            />
          }
          groups={secureRouteGroupsProd}
        />
      ),
    },
    {
      path: `/${subDomainProd}/contactus`,
      element: <ContactUs />,
    },
    {
      //path: `/${subDomainProd}/group-management/group-access`,
      path: `/${subDomainProd}/group-access`,
      element: (
        <SecureRoute
          productName={nameOfProductProd}
          element={
            <GroupAccessTool
              enableDescriptions={false}
              orgId={prmgProdObject.orgID}
            />
          }
          groups={[editableRightsGroupProd]}
        />
      ),
    },
    {
      path: `/${subDomainProd}/landing-page-management`,
      element: (
        <SecureRoute
          productName={nameOfProductProd}
          element={<AdminTileManagement environmentCode="PR_PROD_" />}
          groups={[editableRightsGroupProd]}
        />
      ),
    },
    {
      path: `/${subDomainProd}/signout`,
      element: <SignOut />,
    },
  ],
};

export const prmgUATModeRoutes = {
  element: (
    <Layout
      breakPoint={DefaultSidebarBreakpoint}
      smallHeader={true}
      sidebarMenu={<PRMGUATModeSidebarMenu />}
      contactUsPath={`/${subDomainUAT}/contactus`}
      signOutPath={`/${subDomainUAT}/signout`}
    />
  ),
  children: [
    {
      path: `/${subDomainUAT}`,
      element: (
        <SecureRoute
          productName={nameOfProductUAT}
          element={prmgUATLandingPage}
          groups={secureRouteGroupsUAT}
        />
      ),
    },
    {
      path: `/${subDomainUAT}/executivedashboards`,
      element: (
        <SecureRoute
          productName={nameOfProductUAT}
          element={prmgUATExecutiveLandingPage}
          groups={secureRouteGroupsUAT}
        />
      ),
    },
    {
      path: `/${subDomainUAT}/operations`,
      element: (
        <SecureRoute
          productName={nameOfProductUAT}
          element={prmgUATOperationsLandingPage}
          groups={secureRouteGroupsUAT}
        />
      ),
    },
    {
      path: `/${subDomainUAT}/retail`,
      element: (
        <SecureRoute
          productName={nameOfProductUAT}
          element={prmgUATRetailLandingPage}
          groups={secureRouteGroupsUAT}
        />
      ),
    },
    {
      path: `/${subDomainUAT}/wholesalecorrespondent`,
      element: (
        <SecureRoute
          productName={nameOfProductUAT}
          element={prmgUATWholesaleLandingPage}
          groups={secureRouteGroupsUAT}
        />
      ),
    },
    {
      path: `/${subDomainUAT}/admindashboards`,
      element: (
        <SecureRoute
          productName={nameOfProductUAT}
          element={prmgUATAdminDashboardsLandingPage}
          groups={seeAdminTileGroup}
        />
      ),
    },
    {
      path: `/${subDomainUAT}/chrisgax`,
      element: (
        <SecureRoute
          productName={nameOfProductUAT}
          element={prmgUATChrisGaxLandingPage}
          groups={seeChrisGaxTileGroup}
        />
      ),
    },
    {
      path: `/${subDomainUAT}/product`,
      element: (
        <SecureRoute
          productName={nameOfProductUAT}
          element={
            <AppEmbedWrapper
              disableCompactLiveboardHeader={true}
              disableFunctionality={[
                {
                  functionality: Action.DownloadAsCsv,
                  bypassGroup: downloadAsCSVBypassGroup,
                },
              ]}
              cssRules={appEmbedWrapperCssRulesNoSaveView}
              breakPoint={DefaultSidebarBreakpoint}
              showPrimaryNavbar={true}
              disableProfileAndHelp={true}
              className="ts-full-app h-100"
              pageId={Page.Liveboards}
              orgObject={prmgUATObject}
              disableEditButtonDynamicCodeArray={[
                {
                  code: "PR_UAT_Executive",
                  backup: prmgUATExecutiveLiveboards,
                },
                {
                  code: "PR_UAT_Operations",
                  backup: prmgUATOperationsLiveboards,
                },
                { code: "PR_UAT_Retail", backup: prmgUATRetailLiveboards },
                {
                  code: "PR_UAT_Wholesale",
                  backup: prmgUATWholesaleLiveboards,
                },
                {
                  code: "PR_UAT_Admin",
                  backup: prmgUATAdminLiveboards,
                },
                {
                  code: "PR_UAT_ChrisGax",
                  backup: [],
                },
              ]}
              bypassDataTabDisablingUserEmails={usersToSeeDataTab}
              activateDisableCheckForDomainAndGroup={{
                domain: subDomainUAT,
                group: seeAdminTileGroup,
              }}
              productBlockCode="PRMG UAT"
            />
          }
          groups={secureRouteGroupsUAT}
        />
      ),
    },
    {
      path: `/${subDomainUAT}/metadata-download-tool`,
      element: (
        <SecureRoute
          productName={nameOfProductUAT}
          element={
            <TSMetadataTool
              orgID={prmgUATObject.orgID}
              filenamePostfix={"UAT"}
              url={`${prmgUATObject.externalInfo?.subdomain}.gallusanalytics.com/${prmgUATObject.externalInfo?.productURL}/product?productURL=`}
            />
          }
          groups={[editableRightsGroupUAT]}
        />
      ),
    },
    {
      path: `/${subDomainProd}/metadata-download-tool`,
      element: (
        <SecureRoute
          productName={nameOfProductProd}
          element={
            <TSMetadataTool
              orgID={prmgProdObject.orgID}
              filenamePostfix={"Prod"}
              url={`${prmgProdObject.externalInfo?.subdomain}.gallusanalytics.com/${prmgProdObject.externalInfo?.productURL}/product?productURL=`}
            />
          }
          groups={[editableRightsGroupProd]}
        />
      ),
    },
    {
      path: `/${subDomainUAT}/landing-page-management`,
      element: (
        <SecureRoute
          productName={nameOfProductUAT}
          element={<AdminTileManagement environmentCode="PR_UAT_" />}
          groups={[editableRightsGroupUAT]}
        />
      ),
    },
    {
      path: `/${subDomainUAT}/contactus`,
      element: <ContactUs />,
    },
    {
      path: `/${subDomainUAT}/signout`,
      element: <SignOut />,
    },
    {
      path: "prmg/:slug",
      element: (
        <SecureRoute
          groups={["PRMG"]}
          element={
            <Redirect
              redirectTo={`/${subDomainProd}`}
              redirectMessage="You have accessed an outdated PRMG link. We will redirect you to the main product page."
            />
          }
        />
      ),
    },
    {
      path: "prmg",
      element: (
        <SecureRoute
          groups={["PRMG"]}
          element={
            <Redirect
              redirectTo={`/${subDomainProd}`}
              redirectMessage="You have accessed an outdated PRMG link. We will redirect you to the main product page."
            />
          }
        />
      ),
    },
    {
      path: "prmgUAT",
      element: (
        <SecureRoute
          groups={["PRMGUAT"]}
          element={
            <Redirect
              redirectTo={`/${subDomainUAT}`}
              redirectMessage="You have accessed an outdated PRMG link. We will redirect you to the main product page."
            />
          }
        />
      ),
    },
    {
      path: "prmgUAT/:slug",
      element: (
        <SecureRoute
          groups={["PRMGUAT"]}
          element={
            <Redirect
              redirectTo={`/${subDomainUAT}`}
              redirectMessage="You have accessed an outdated PRMG link. We will redirect you to the main product page."
            />
          }
        />
      ),
    },
  ],
};
